const assetVersion = typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : 'local-dev'

export function getVersionedAssetUrl(path: string): string {
  if (!path) return path

  const [urlPath, hash] = path.split('#')
  const separator = urlPath.includes('?') ? '&' : '?'
  const versionedPath = `${urlPath}${separator}v=${encodeURIComponent(assetVersion)}`

  if (!hash) return versionedPath

  return `${versionedPath}#${hash}`
}
